module.exports = __webpack_public_path__ + "img/hall-of-fame_4.cff572c2.jpg";